import {Component, input, output, ChangeDetectionStrategy} from "@angular/core"
import {MatButtonModule} from "@angular/material/button"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-add-file-card",
    imports: [MatButtonModule],
    templateUrl: "./add-file-card.component.html",
    styleUrl: "./add-file-card.component.scss",
})
export class AddFileCardComponent {
    readonly $squareFormat = input(false, {alias: "squareFormat"})
    readonly filesSelected = output<File[]>()

    selectFiles(event: Event) {
        const inputElement = event.target as HTMLInputElement
        if (inputElement.files) {
            this.filesSelected.emit(Array.from(inputElement.files))
            // reset value to make event fire again if same file is selected
            inputElement.value = ""
        }
    }
}
